<template>
  <v-app id="app">
    <v-main>
      <v-container class="mc-main-container" style="min-height: 85vh">
        <vue-extend-layouts/>
      </v-container>
      <FooterContacts />
    </v-main>
  </v-app>
</template>

<script>
import VueExtendLayouts from 'vue-extend-layout'
import FooterContacts from "@/components/FooterContacts";

export default {
  name: 'App',
  components: { VueExtendLayouts, FooterContacts: FooterContacts }
}
</script>

